import { routeName } from '~/@common/constants/route'

// 사용자 타입: 학생 또는 학부모
type UserType = 'STUDENT' | 'PARENT'

/**
 * 사용자 역할에 따른 기본 진입 페이지를 반환한다.
 * 선생님앱 getEntrancePage() 패턴 미러링.
 *
 * PARENT → /parent (학부모 홈)
 * STUDENT → /student (학습홈)
 *
 * @param userType - 사용자 타입 (기본값: STUDENT)
 * @returns 진입 페이지 경로 문자열
 */
export const getEntrancePage = (userType?: UserType): string => {
  // 학부모는 학부모 홈으로 진입
  if (userType === 'PARENT') return routeName.parent.defaultPath

  // 학생(기본값 포함)은 학습홈으로 진입
  return routeName.student.defaultPath
}
